import * as React from 'react';

import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {NutshellLogoMarkIcon} from 'shells/icon/svg/nutshell-logo-mark-icon';
// @ts-expect-error - imported from .js/.jsx file
import {PhoneCallIcon} from 'shells/icon/svg/phone-call-icon';

import type {ExternalServiceType} from 'nutshell-graphql-types';

import {getServiceTypeIconForConnectionWidgets} from '../calls/helpers';

import {getServiceTypeIcon, getServiceTypeColor} from './helpers';
import type {ExternalServiceTypeFrontend} from './tables/types';

type Props = {
    serviceType: ExternalServiceType | ExternalServiceTypeFrontend;
    firstEnabledIntegrationType?: ExternalServiceType | null | undefined;
};

export function ProviderSyncIllustration(props: Props) {
    let providerIcon;
    if (props.serviceType === 'PHONES' && props.firstEnabledIntegrationType) {
        providerIcon = React.cloneElement(
            getServiceTypeIconForConnectionWidgets(props.firstEnabledIntegrationType),
            {size: 60}
        );
    } else if (props.serviceType === 'PHONES') {
        providerIcon = <PhoneCallIcon wrapWithDiv={false} size={60} color='#4d4540' />;
    } else {
        providerIcon = React.cloneElement(getServiceTypeIcon(props.serviceType), {size: 60});
    }

    const providerColor =
        props.serviceType === 'PHONES' ? '#4d4540' : getServiceTypeColor(props.serviceType);

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 24,
            }}
        >
            {/* Provider Icon */}
            <div
                style={{
                    width: 100,
                    height: 100,
                    borderRadius: 16,
                    backgroundColor: '#f7f7f7',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: `2px solid ${providerColor}20`,
                }}
            >
                {providerIcon}
            </div>

            {/* Nutshell Logo */}
            <div
                style={{
                    width: 100,
                    height: 100,
                    borderRadius: 16,
                    backgroundColor: '#f7f7f7',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '2px solid #fe580020',
                }}
            >
                <NutshellLogoMarkIcon
                    wrapWithDiv={false}
                    fill={colors.orange}
                    color={colors.orange}
                    size={60}
                />
            </div>
        </div>
    );
}
